/* LP product grid — per-tab infinite scroll.
   Each tab fetches ITS OWN collection through the alternate `collection.lp-cards`
   template (?view=lp-cards&page=N), scrapes the .js-lpg-result cards and appends 12
   more when the shopper nears the bottom of the active tab. No shared paginate, no
   "view all" button — the two tabs page independently. */
(function () {
  function init() {
    document.querySelectorAll('[data-lpg-section]').forEach(setupSection);
  }

  function setupSection(section) {
    var state = new Map(); // sentinel -> { intersecting: bool }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var s = state.get(e.target) || {};
        s.intersecting = e.isIntersecting;
        state.set(e.target, s);
        if (e.isIntersecting) tryLoad(e.target);
      });
    }, { rootMargin: '600px 0px' });

    section.querySelectorAll('[data-lpg-panel]').forEach(function (panel) {
      var sentinel = panel.querySelector('[data-lpg-sentinel]');
      if (sentinel) observer.observe(sentinel);
    });

    function tryLoad(sentinel) {
      var panel = sentinel.closest('[data-lpg-panel]');
      if (!panel || panel.hidden) return;
      if (sentinel.dataset.lpgHasNext !== 'true' || sentinel.dataset.lpgFetching === '1') return;

      var base = sentinel.dataset.lpgCollectionUrl;
      if (!base) return;
      var next = parseInt(sentinel.dataset.lpgPage || '1', 10) + 1;
      sentinel.dataset.lpgFetching = '1';

      var url = new URL(base, window.location.origin);
      url.searchParams.set('view', 'lp-cards');
      url.searchParams.set('page', String(next));

      fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var newCells = doc.querySelectorAll('.js-lpg-result');
          var grid = panel.querySelector('[data-lpg-grid]');

          if (grid && newCells.length) {
            var frag = document.createDocumentFragment();
            newCells.forEach(function (c) { frag.appendChild(document.importNode(c, true)); });
            grid.appendChild(frag);
          }

          var marker = doc.querySelector('[data-lpg-cards-next]');
          var hasNext = !!marker && marker.dataset.lpgCardsNext === 'true' && newCells.length > 0;

          sentinel.dataset.lpgPage = String(next);
          sentinel.dataset.lpgHasNext = hasNext ? 'true' : 'false';
          sentinel.dataset.lpgFetching = '';

          // Best-effort: let Stamped hydrate star badges on the new cards.
          if (window.StampedFn && typeof window.StampedFn.loadBadges === 'function') {
            try { window.StampedFn.loadBadges(); } catch (err) { /* noop */ }
          }

          if (!hasNext) {
            observer.unobserve(sentinel);
            return;
          }
          // Keep filling while the sentinel is still on screen (tall viewports).
          var s = state.get(sentinel);
          if (s && s.intersecting) tryLoad(sentinel);
        })
        .catch(function () {
          sentinel.dataset.lpgFetching = '';
          observer.unobserve(sentinel);
        });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
